import React from 'react';
import { Box, Typography } from 'vindi-ds-components';
import token from 'vindi-ds-tokens';
import PricingType from '../pricing_type';

function PricingHeader({ schemaType, unit }) {
  return (
    <Box display='flex' justifyContent='space-between' mb={token.spacing.small.value}>
      <PricingType schemaType={schemaType} />
      <Box>
        <Typography variant='body2' component='p'>
          Medida
        </Typography>
        <Typography variant='body1' component='p'>
          {unit || '-' }
        </Typography>
      </Box>
    </Box>
  );
}

export default PricingHeader;
